var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardActiveBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 80,
    viewBox: "0 0 289 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2447_78",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 289,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H279C284.523 0 289 4.47715 289 10V70C289 75.5229 284.523 80 279 80H9.99999C4.47714 80 0 75.5229 0 70V10Z",
    fill: "url(#paint0_linear_2447_78)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2447_78)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.939 -25.6611C128.694 -21.5681 156.942 -17.3594 184.955 -17.3594C241.499 -17.3594 276.435 -23.7131 295.001 -14.1152V127.222C295.001 132.744 290.524 137.221 285.001 137.222H243.97C160.241 109.445 70.9172 -15.101 -2 -0.000976562C-1.99992 -12.3363 1.64007 -20.5025 8.18652 -25.6611H102.939Z",
    fill: "#FFC111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.7969 -26C103.123 -21.8031 132.163 -17.3594 160.955 -17.3594C247.56 -17.3594 289.289 -34.1916 294.039 15.915V127C294.039 132.523 289.562 137 284.039 137H219.306C135.769 108.789 46.7245 -15.0611 -26 -0.000976562C-25.9999 -12.6101 -22.1964 -20.8628 -15.373 -26H76.7969Z",
    fill: "#FFC111",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 14,
    cy: 67,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 39,
    cy: 61,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 33,
    cy: 35,
    r: 7,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_78",
    x1: 139.139,
    y1: -4.46667,
    x2: -127.356,
    y2: 67.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865951,
    stopColor: "#FF9E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED511"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardActiveBackground);
export default __webpack_public_path__ + "static/media/CardActiveBackground.108518cabd1cb59150c5dd09b142c289.svg";
export { ForwardRef as ReactComponent };